import type { RampConfig, RampShape } from '@gorampe/calc-engine';
import type { SceneLayout } from '../types';

type FFShape = Extract<RampShape, { kind: 'freeform' }>;

/**
 * MVP stub: returns empty layout. Freeform layout is a post-v2 feature.
 * Future: walk node/edge graph, layout each tread segment in 3D.
 */
export function layoutFreeform(_config: RampConfig, _shape: FFShape): SceneLayout {
  return {
    platforms: [],
    treads: [],
    rails: [],
    landings: [],
    pattes: [],
    cornerPosts: [],
    transitions: [],
    hardwareGroups: [],
  };
}
